import React from 'react';

const STATUS_CONFIG = {
  // Order Statuses
  PENDING: { label: 'Bekliyor', class: 'warning', icon: 'clock' },
  PROCESSING: { label: 'Hazırlanıyor', class: 'info', icon: 'cog' },
  SHIPPED: { label: 'Kargolandı', class: 'primary', icon: 'truck' },
  DELIVERED: { label: 'Teslim Edildi', class: 'success-soft', icon: 'check-circle' },
  CANCELLED: { label: 'İptal', class: 'danger-soft', icon: 'times-circle' },
  REFUNDED: { label: 'İade', class: 'secondary', icon: 'undo' },

  // Subscription Statuses
  ACTIVE: { label: 'Aktif', class: 'success-soft', icon: 'check' },
  INACTIVE: { label: 'Pasif', class: 'secondary', icon: 'times' },
  PAUSED: { label: 'Durduruldu', class: 'warning', icon: 'pause' },
  CANCELLED_SUB: { label: 'İptal', class: 'danger-soft', icon: 'times' }, // Using unique key
  EXPIRED: { label: 'Süresi Doldu', class: 'secondary', icon: 'hourglass-end' },

  // Generic
  TRUE: { label: 'Evet', class: 'success', icon: 'check' },
  FALSE: { label: 'Hayır', class: 'secondary', icon: 'times' },
};

// Map backend status strings to config keys if they differ
const normalizeStatus = (status) => {
  if (!status) return 'FALSE';
  const upper = status.toString().toUpperCase();
  if (upper === 'CANCELLED' && status.subscription) return 'CANCELLED_SUB';
  return upper;
};

const StatusBadge = ({ status, type = 'default' }) => {
  const statusKey = normalizeStatus(status);
  const config = STATUS_CONFIG[statusKey] || { label: status, class: 'secondary', icon: 'circle' };

  // Mapping old bootstrap classes to new design system vars
  const getStyle = (className) => {
    switch (className) {
      case 'success-soft': return { backgroundColor: 'var(--status-success-bg)', color: 'var(--status-success-text)' };
      case 'warning': return { backgroundColor: 'var(--status-warning-bg)', color: 'var(--status-warning-text)' };
      case 'danger-soft': return { backgroundColor: 'var(--status-danger-bg)', color: 'var(--status-danger-text)' };
      case 'info': return { backgroundColor: 'var(--status-info-bg)', color: 'var(--status-info-text)' };
      case 'primary': return { backgroundColor: 'rgba(253, 126, 20, 0.1)', color: '#fd7e14' };
      default: return { backgroundColor: 'rgba(108, 117, 125, 0.1)', color: '#6c757d' };
    }
  };

  const style = getStyle(config.class);

  return (
    <span
      className="badge rounded-pill d-inline-flex align-items-center"
      style={{
        ...style,
        padding: '0.5em 0.8em',
        fontWeight: 500,
        fontSize: '0.75rem',
        border: '1px solid currentColor' // Optional: adds outline
      }}
    >
      <i className={`fas fa-${config.icon} me-2`}></i>
      {config.label}
    </span>
  );
};

export default StatusBadge;
